import axios from "axios";

const instance: any = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
export default instance;
